import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const CloseIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1049 1.59445C11.298 1.40136 11.298 1.08819 11.1048 0.894975C10.9116 0.70176 10.5985 0.701663 10.4054 0.894757L5.99919 5.30018L1.60837 0.924041C1.4149 0.731213 1.10174 0.731737 0.908911 0.925212C0.716083 1.11869 0.716607 1.43185 0.910082 1.62468L5.29967 5.99958L0.894822 10.4037C0.701695 10.5968 0.701731 10.9099 0.894901 11.1032C1.08807 11.2964 1.40123 11.2965 1.59436 11.1034L6.00045 6.69803L10.3909 11.0738C10.5844 11.2666 10.8975 11.2661 11.0904 11.0726C11.2832 10.8791 11.2827 10.566 11.0892 10.3732L6.69998 5.99862L11.1049 1.59445Z"
        fill={color}
      />
      <path
        d="M11.1048 0.894975L10.928 1.07173L10.928 1.07173L11.1048 0.894975ZM11.1049 1.59445L11.2817 1.77124L11.2817 1.77124L11.1049 1.59445ZM10.4054 0.894757L10.2286 0.717965L10.2286 0.717965L10.4054 0.894757ZM5.99919 5.30018L5.82271 5.47725L5.99947 5.65342L6.17595 5.47697L5.99919 5.30018ZM1.60837 0.924041L1.78485 0.746968L1.78485 0.746968L1.60837 0.924041ZM0.908911 0.925212L0.731838 0.748731L0.731838 0.748731L0.908911 0.925212ZM0.910082 1.62468L0.733602 1.80175L0.733602 1.80175L0.910082 1.62468ZM5.29967 5.99958L5.47643 6.17638L5.65353 5.9993L5.47615 5.82251L5.29967 5.99958ZM0.894822 10.4037L0.71806 10.2269L0.71806 10.2269L0.894822 10.4037ZM0.894901 11.1032L0.718104 11.2799L0.718105 11.2799L0.894901 11.1032ZM1.59436 11.1034L1.41759 10.9266L1.41759 10.9266L1.59436 11.1034ZM6.00045 6.69803L6.17693 6.52095L6.00017 6.34478L5.82369 6.52123L6.00045 6.69803ZM10.3909 11.0738L10.2144 11.2509L10.2144 11.2509L10.3909 11.0738ZM11.0904 11.0726L10.9133 10.8961L10.9133 10.8961L11.0904 11.0726ZM11.0892 10.3732L11.2657 10.1961L11.2657 10.1961L11.0892 10.3732ZM6.69998 5.99862L6.52321 5.82183L6.34611 5.9989L6.52349 6.17569L6.69998 5.99862ZM10.928 1.07173C11.0236 1.16738 11.0235 1.32226 10.9281 1.41766L11.2817 1.77124C11.5725 1.48046 11.5723 1.009 11.2816 0.718219L10.928 1.07173ZM10.5821 1.07155C10.6775 0.97615 10.8324 0.97609 10.928 1.07173L11.2816 0.718219C10.9909 0.42743 10.5194 0.427175 10.2286 0.717965L10.5821 1.07155ZM6.17595 5.47697L10.5821 1.07155L10.2286 0.717965L5.82243 5.12339L6.17595 5.47697ZM1.43189 1.10111L5.82271 5.47725L6.17567 5.1231L1.78485 0.746968L1.43189 1.10111ZM1.08598 1.10169C1.18134 1.00601 1.33621 1.00575 1.43189 1.10111L1.78485 0.746968C1.49359 0.456673 1.02213 0.457462 0.731838 0.748731L1.08598 1.10169ZM1.08656 1.4476C0.990882 1.35224 0.990623 1.19737 1.08598 1.10169L0.731838 0.748731C0.441543 1.04 0.442332 1.51145 0.733602 1.80175L1.08656 1.4476ZM5.47615 5.82251L1.08656 1.4476L0.733602 1.80175L5.12318 6.17666L5.47615 5.82251ZM1.07158 10.5805L5.47643 6.17638L5.1229 5.82279L0.71806 10.2269L1.07158 10.5805ZM1.0717 10.9264C0.976074 10.8308 0.976165 10.6759 1.07158 10.5805L0.71806 10.2269C0.427225 10.5177 0.427387 10.9891 0.718104 11.2799L1.0717 10.9264ZM1.41759 10.9266C1.32218 11.022 1.16732 11.022 1.0717 10.9264L0.718105 11.2799C1.00883 11.5707 1.48028 11.571 1.77112 11.2802L1.41759 10.9266ZM5.82369 6.52123L1.41759 10.9266L1.77112 11.2802L6.17721 6.87482L5.82369 6.52123ZM10.5674 10.8967L6.17693 6.52095L5.82397 6.8751L10.2144 11.2509L10.5674 10.8967ZM10.9133 10.8961C10.8179 10.9918 10.6631 10.9921 10.5674 10.8967L10.2144 11.2509C10.5057 11.5412 10.9771 11.5404 11.2674 11.2491L10.9133 10.8961ZM10.9127 10.5502C11.0084 10.6456 11.0086 10.8005 10.9133 10.8961L11.2674 11.2491C11.5577 10.9578 11.5569 10.4864 11.2657 10.1961L10.9127 10.5502ZM6.52349 6.17569L10.9127 10.5502L11.2657 10.1961L6.87646 5.82155L6.52349 6.17569ZM10.9281 1.41766L6.52321 5.82183L6.87674 6.17541L11.2817 1.77124L10.9281 1.41766Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

CloseIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

CloseIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default CloseIcon;
